'use strict'
const { BryExtension } = window
import constCertificados from "@/constants/certificates"

// centralizando comunicacao da extensao da bry e
// visualização do modal de certificados
class Bry {

  static init () {
    Bry.certificates = []
    Bry.selectedCertificate = null
    Bry.modalOpened = true
  }

  static verifyExtension () {
    // verifica existencia da extensão
    return (typeof BryExtension !== 'undefined' && typeof BryExtension.listCertificates === 'function')
  }

  static getExtension () {
    // redireciona para baixar plugin
    const isFirefox = typeof InstallTrigger !== 'undefined'
    const isChrome = !!window.chrome

    if (isFirefox) {
      window.open(this.extensions.firefox, '_blank')
    } else if (isChrome) {
      window.open(this.extensions.firefox, '_blank')
    } else {
      throw new Error('A extensão para assinatura digital não está disponível para seu navegador.')
    }
  }

  // essa funcao seta o certificado em selectedCertificate
  static setCertificate (certificate) {
    this.selectedCertificate = certificate

    // se existir um modal de certificado aberto
    // ira ser fechado e variavel local alterada
    if (this.modalOpened) {
      this.modalOpened = false
      window.modalGlobal.hide()
    }
  }

  // essa funcao irá esperar o retorno do modal
  static async waitModalCertificate () {
    // metodo recursivo para verificar se o modal foi
    // fechado e o certificado selecionado
    const verify = (resolve) => {
      if (this.modalOpened && !Bry.selectedCertificate) {
        // a cada segundo ele verifica se as variaveis foram mudadas
        setTimeout(() => {
          return verify(resolve)
        }, 1000)
      } else {
        return resolve(true)
      }
    }

    return new Promise((resolve) => {
      // indicando que existe um modal de certificado aberto

      window.modalGlobal.show('certificados')
      this.modalOpened = true

      return verify(resolve)
    })
  }

  static prepareContentForSignature (base64Content, nonce) {
    return {
      nonce,
      hashes: [
        base64Content
      ]
    }
  }

  static async sign (certId, signatures, nonce) {
    const input = {
      nonce: nonce,
      algoritmoHash: 'SHA256',
      formatoDadosEntrada: 'BASE64',
      formatoDadosSaida: 'BASE64',
      assinaturas: Array.isArray(signatures) ? signatures : [signatures]
    }

    return BryExtension.sign(certId, JSON.stringify(input))
  }

  // funcao que pega todos certificados disponíveis
  static async getAllCertificates () {

    // descomentar para retornar certificados mockados
    //return constCertificados

    if (!this.verifyExtension()) {
      this.getExtension()
      return
    }

    // retornando listagem de certificados
    const certificates = await BryExtension.listCertificates().then((certificates) => {
      return certificates.filter((certificate) => certificate.validity === 'VALID')
    })

    return certificates
  }

  // funcao q irá pegar o certificado
  static async getCertificate () {
    this.init()

    // pegandos certificados disponíveis
    const certificates = await this.getAllCertificates()

    // disparando erro
    if (!certificates) {
      window.displayMessage('error', 'Erro', 'Nenhum certificado encontrado.')
      throw new Error('Nenhum certificado encontrado')
      return
    } 
    else if (certificates.length == 0) { 
      window.displayMessage('error', 'Erro', 'Nenhum certificado encontrado.')
      throw new Error('Nenhum certificado encontrado')
      return
    }

    this.certificates = certificates

    //verificando se é mais de um certificado
    if (certificates.length > 1) {
      // deixamos a responsabilidade do modal para o service da Bry
      // assim evitamos repetir código
      await this.waitModalCertificate()
    } else {
      // caso só seja um certificado
      this.setCertificate(certificates[0])
    }

    // retornando certificado
    return this.selectedCertificate
  }
}

// definindo atributos staticos
Bry.extensions = {
  firefox: 'https://www.bry.com.br/downloads/extension/firefox/assinatura_digital_bry.xpi',
  chrome: 'https://chrome.google.com/webstore/detail/dhikfimimcjpoaliefjlffaebdeomeni'
}
// lista de certificados que será usado para o modal
Bry.certificates = []

// certificado que será usado
Bry.selectedCertificate = null
// modal certificados
Bry.modalOpened = false

export default Bry
